<script lang="ts" setup>
import { NuxtUiIcons } from '@shared/types'
import { Modal } from '@/types'

const accessStore = useAccessStore()
const modalStore = useSharedModalStore()
const onboardingStore = useOnboardingStore()

const isDepositLoading = computed(
  () =>
    onboardingStore.isDepositInFlight &&
    !onboardingStore.activeBridgeState?.error
)

const isUserActionRequired = computed(
  () =>
    onboardingStore.requiresResume || !!onboardingStore.activeBridgeState?.error
)

function onDeposit() {
  modalStore.openModal(Modal.Onboarding)
}

function onGetAccess() {
  modalStore.openModal(Modal.EstablishConnection)
}
</script>

<template>
  <div>
    <div v-if="accessStore.userHasAccess" class="relative inline-flex">
      <UButton
        v-bind="{ size: 'xs' }"
        class="min-w-28 justify-center"
        @click="onDeposit"
      >
        <template v-if="isDepositLoading" #leading>
          <UIcon :name="NuxtUiIcons.Loading2" class="animate-spin size-3" />
        </template>
        {{ $t('common.deposit') }}
      </UButton>
      <span
        v-if="isUserActionRequired"
        class="size-2.5 bg-error rounded-full absolute -top-1 -right-1 animate-pulse"
      />
      <span v-if="isUserActionRequired" class="sr-only">
        {{ $t('common.actionRequired') }}
      </span>
    </div>

    <UButton
      v-else
      v-bind="{ size: 'xs' }"
      class="min-w-28 justify-center"
      @click="onGetAccess"
    >
      {{ $t('connect.access.getAccess') }}
    </UButton>
  </div>
</template>
